"use client";
import { Asset as e } from "../assets/Asset.js";
import { AssetSvg as t } from "../assets/AssetSvg.js";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
import { useId as i } from "react";
//#region src/components/flags/BBFlag.tsx
var a = (e) => {
	let a = i();
	return /* @__PURE__ */ r(t, {
		viewBox: "0 0 24 24",
		fill: "none",
		...e,
		children: [/* @__PURE__ */ r("g", {
			clipPath: `url(#${a}-clip0_103_20)`,
			children: [
				/* @__PURE__ */ n("mask", {
					id: `${a}-path-1-inside-1_103_20`,
					fill: "white",
					children: /* @__PURE__ */ n("path", { d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z" })
				}),
				/* @__PURE__ */ n("path", {
					d: "M-6 0H30V24H-6V0Z",
					fill: "#FFC726"
				}),
				/* @__PURE__ */ n("path", {
					d: "M-6 0H6V24H-6V0ZM18 0H30V24H18V0Z",
					fill: "#00267F"
				}),
				/* @__PURE__ */ n("path", {
					d: "M16.8588 7.08911L14.6153 7.95929C14.5676 8.05402 14.209 8.48841 14.0413 11.6828H12.8448V7.4428L11.9648 5.52139L11.0848 7.41613V11.6828H9.88761C9.71989 8.48771 9.34024 7.99999 9.29323 7.90455L7.07007 7.08841C7.08059 7.11016 8.15077 9.28771 8.15077 12.5628V13.4428H11.0848V18.4302H12.8448V13.4428H15.7788V12.5628C15.7788 10.8695 16.0715 9.47367 16.3178 8.60069C16.5859 7.64841 16.8581 7.09262 16.8609 7.08701L16.8588 7.08911Z",
					fill: "black"
				})
			]
		}), /* @__PURE__ */ n("defs", { children: /* @__PURE__ */ n("clipPath", {
			id: `${a}-clip0_103_20`,
			children: /* @__PURE__ */ n("path", {
				d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
				fill: "white"
			})
		}) })]
	});
}, o = {
	12: {
		Artwork: a,
		width: 12,
		height: 12
	},
	16: {
		Artwork: a,
		width: 16,
		height: 16
	},
	20: {
		Artwork: a,
		width: 20,
		height: 20
	},
	24: {
		Artwork: a,
		width: 24,
		height: 24
	}
}, s = ({ size: t = 16, ...r }) => /* @__PURE__ */ n(e, {
	source: o[t],
	frame: "circle",
	...r
});
//#endregion
export { s as BBFlag };
